export default __webpack_public_path__ + "static/IBMPlexSans-Bold-Latin1-77eecc3d68f018bc433d86a62f8260dc.woff2";